import React, { Component } from "react";
import "./WeightBenefitsTabs.css";
import _ from "lodash";

class WeighBenefitsTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleted: false
    };
  }

  componentWillMount() {
    if (!_.isEmpty(this.props.benefitsData)) {
      this.setState({
        data: this.props.benefitsData
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.benefitsData)) {
      this.setState({
        data: nextProps.benefitsData
      });
    }
    if (nextProps.competeData.length > 0 && nextProps.oldData.length > 0 && nextProps.tabs) {
      let DataforAddDeleteOld = {};
      let DataforAddDeleteNew = {};
      nextProps.tabs.map(tab => {
        DataforAddDeleteOld[tab.groupId + tab.segmentId] = [];
        nextProps.oldData.map(item => {
          if (tab.groupId === item.groupId && tab.segmentId === item.segmentId && !item.new) {
            DataforAddDeleteOld[tab.groupId + tab.segmentId].push(item);
          }
        });
      });
      nextProps.tabs.map(tab => {
        DataforAddDeleteNew[tab.groupId + tab.segmentId] = [];
        nextProps.competeData.map(item => {
          if (tab.groupId === item.groupId && tab.segmentId === item.segmentId && !item.new) {
            DataforAddDeleteNew[tab.groupId + tab.segmentId].push(item);
          }
        });
      });
      this.setState({
        DataforAddDeleteOld: DataforAddDeleteOld,
        DataforAddDeleteNew: DataforAddDeleteNew
      });
    }
  }

  elementInfiniteLoad() {
    return (
      <div className="col-sm-12">
        <div className="spinner3">
          <div className="rect1" />
          <div className="rect2" />
          <div className="rect3" />
          <div className="rect4" />
          <div className="rect5" />
        </div>
      </div>
    );
  }

  countWT(groupId, segmentId) {
    let wt = 0;
    for (let i of this.props.competeData) {
      if (groupId === i.groupId && segmentId === i.segmentId) {
        wt += +i.wt;
      }
    }
    return wt;
  }

  countCriticalWT(groupId, segmentId) {
    let wt = 0;
    for (let i of this.props.competeData) {
      if (groupId === i.groupId && segmentId === i.segmentId) {
        wt += +i.criticalCapacity[0].ccWt;
        if (i.criticalCapacity[1]) {
          wt += +i.criticalCapacity[1].ccWt;
        }
      }
    }
    return wt;
  }
  onDelete = () => {
    this.setState({ deleted: true });
  };
  renderOptions = (newItem, oldItem) => {
    for (const i of oldItem) {
      const findedItem = _.find(
        newItem,
        item => i.benefitId === item.benefitId
      );
      if (!findedItem) {
        let benefitName = this.props.benefitsData.find(
          r => r.benefitId === i.benefitId
        );
        return <option value={i.benefitId}>{benefitName ? benefitName.benefitName : i.name}</option>;
      }
    }
  };
  render() {
    let tabs = this.props.tabs.map((item, key) => {
      return (
        <li
          className="nav-item"
          key={`${item.groupId + `id` + item.segmentId}`}
          onClick={()=>this.props.onTabChange(key)}
        >
          <a
            data-toggle="tab"
            className={key === this.props.tabStep ? "nav-link active show" : "nav-link"}
            href={`#${item.groupId + `id` + item.segmentId}`}
            aria-controls={`${item.groupId + `id` + item.segmentId}`}
            aria-selected="true"
          >
            {item.groupName + ` - ` + item.segmentName}
          </a>
        </li>
      );
    });

    let tabsContent = this.props.tabs.map((tabItem, key) => {
      let countWT = 0;
      let countCCWT = 0;
      let countScore = 0;
      let countConpenScore = [];

      const groupId = this.props.tabs.find(r => r.groupId === tabItem.groupId).groupId;
      const segmentId = this.props.tabs.find( r => r.segmentId === tabItem.segmentId).segmentId;

      let diferencCCWT = 0;
      let uniq = null
      this.props.oldData.map(oldData=>{
        if(oldData.groupId ===groupId && oldData.segmentId === segmentId){
          let exsist = this.props.competeData.find(i=>i.benefitId === oldData.benefitId && i.groupId === oldData.groupId && i.segmentId===oldData.segmentId)
          if(!exsist){
            uniq=oldData
          }
        }
      })
      if(uniq){
        diferencCCWT-=uniq.totalScore
      }
      return (
        <div id={groupId + `id` + segmentId}
          className={
            key === this.props.tabStep
              ? "tab-pane fade show active tabContentdiv compete-tab-content"
              : "tab-pane fade tabContentdiv compete-tab-content"
          }
          role="tabpanel"
          key={key}
        >
          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12">
              {/* {this.props.tabs.map((item, key) => { */}
              <div className="compete-tab-content-box">
                <div className="project-name">
                  {this.props.challengeStatementData &&
                    this.props.challengeStatementData.Count > 0 &&
                    this.props.challengeStatementData.Items.map((name, key) => {
                      return <p>{name.chalange.horizon1.company}</p>;
                    })}
                </div>
                <table className="compete-capability-table">
                  <thead>
                    <tr>
                      <th>Benefits Sought</th>
                      <th>WT</th>
                      <th>Critical Capability</th>
                      <th>CC WT</th>
                      <th>
                        Rating <br /> (1-10)
                      </th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.competeData &&
                      !_.isEmpty(this.props.benefitsData) &&
                      this.props.competeData.map((i, index) => {
                        if (groupId === i.groupId && segmentId === i.segmentId) {
                          let benefitName;
                          this.props.benefits.benefitsLadderData.Items[0].data.map(
                            item => {
                              if (item.groupId === i.groupId) {
                                benefitName = item.benefits.find( r => r.id === i.benefitId && r.important);
                              }
                            }
                          );
                          // let benefitName = this.props.benefitsData.find(r => r.groupId === i.groupId && r.benefitId === i.benefitId);

                          let oldI = this.props.oldData.find( r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId );
                          if(!oldI){
                            oldI = _.cloneDeep(this.props.competeData.find( r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId  && i.new))
                            oldI.totalScore= 0
                            oldI.wt = 0
                          }
                          return (
                            <tr>
                              <td>
                                <div className="td-box">
                                  {benefitName ?
                                    benefitName.name :
                                    <input
                                      type="text"
                                      value={i.name}
                                      onChange={(e)=>this.props.onChangeNewBenefitName(i.groupId,i.segmentId,i.benefitId,e.target.value)}
                                    />
                                  }
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  <input
                                    disabled={this.props.result ? true : false}
                                    className="wt-input"
                                    type="number"
                                    value={i.wt}
                                    onChange={e => this.props.onChangeWT(e, i)}
                                  />
                                  {i.wt - oldI.wt !== 0 && (
                                    <div className="position-number">
                                      {i.wt - oldI.wt}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    return (
                                      <textarea
                                        disabled={i.new ? false : true}
                                        className={
                                          index === 0 ? "long-box capability-textarea" : "long-box capability-textarea"
                                        }
                                        type="text"
                                        value={critItem.text}
                                        onChange={e =>
                                          this.props.onChangeCriticalCapability(
                                            e,
                                            i,
                                            index
                                          )
                                        }
                                        onKeyPress={(e)=> e.key==="Enter" && i.name && i.wt && i.criticalCapacity[0].text &&  i.criticalCapacity[0].ccWt &&  this.props.onClickPlus(i)}
                                      />
                                    );
                                  })}
                                  {i.new && i.criticalCapacity.length > 1  &&  !this.props.result &&
                                    <i className="fas fa-minus-circle" onClick={() => this.props.onClickMin(i)}></i>
                                  }

                                  {i.new && i.criticalCapacity.length === 1 &&  !this.props.result &&
                                    <i className="fas fa-plus-circle" onClick={() => {i.name && i.wt && i.criticalCapacity[0].text && i.criticalCapacity[0].ccWt &&  this.props.onClickPlus(i)}}></i>
                                  }
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    let ccWt = i.criticalCapacity.length > 1 ? critItem.ccWt : critItem.ccWt;
                                    // console.log('______________________________________', ccWt);

                                    let oldCritItem = oldI.criticalCapacity.find( r => r.id === critItem.id );

                                    return (
                                      <div className="td-box-small">
                                        <input
                                          disabled={  this.props.result ? true : false }
                                          className="wt-input"
                                          type="number"
                                          value={ccWt}
                                          onChange={e => this.props.onChangeCCWT(e, i, index) }
                                        />
                                        {ccWt - oldCritItem.ccWt !== 0 && (
                                          <div className="position-number">
                                            {ccWt - oldCritItem.ccWt}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    let oldcriticalCapacity = oldI.criticalCapacity.find( r => r.id === critItem.id);

                                    let val = critItem.rating ? +critItem.rating : 1;

                                    let oldVal = oldcriticalCapacity.rating ? +oldcriticalCapacity.rating : 1;

                                    return (
                                      <div className="td-box-small">
                                        <select
                                          disabled={ this.props.result ? true : false }
                                          className="form-control"
                                          value={val}
                                          onChange={e => this.props.onChangeRatingValue(e,i,index)}
                                          style={{ outline: "none" }}
                                        >
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                          <option value="3">3</option>
                                          <option value="4">4</option>
                                          <option value="5">5</option>
                                          <option value="6">6</option>
                                          <option value="7">7</option>
                                          <option value="8">8</option>
                                          <option value="9">9</option>
                                          <option value="10">10</option>
                                        </select>
                                        {+val - +oldVal !== 0 && (
                                          <div className="position-number">
                                            {+val - +oldVal}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    let valScore = critItem.rating ? +critItem.ccWt * +critItem.rating : +critItem.ccWt;
                                    let oldValScore = oldI.criticalCapacity[index].rating ? +oldI.criticalCapacity[index].ccWt * +oldI.criticalCapacity[index].rating  : +oldI.criticalCapacity[index].ccWt
                                    let lengthOfCapacity = i.criticalCapacity.length;
                                    countScore = +countScore + valScore;
                                    return (
                                      <div className="score-box">
                                        {valScore}
                                        {+valScore - oldValScore !== 0 && (
                                          <div className="position-number">
                                            {+valScore - oldValScore}
                                            <span style={{ display: "none" }}>
                                              {
                                                (diferencCCWT += +valScore - oldValScore)
                                              }
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      })}

                    <tr className="last-row">
                      <td></td>
                      <td className="first-value">
                        <strong>{this.countWT(groupId, segmentId)}</strong>
                      </td>
                      <td></td>
                      <td className="first-value">
                        <strong>
                          {this.countCriticalWT(groupId, segmentId)}
                        </strong>
                      </td>
                      <td></td>
                      <td className="first-value">
                        {diferencCCWT !== 0 && (
                          <div className="position-number">{diferencCCWT}</div>
                        )}
                        <strong>{countScore}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12">
              <div className="define-tab-content-box">
                <div className="row">
                  {this.props.competeData.find( r => r.groupId === tabItem.groupId && r.segmentId === tabItem.segmentId).competitorTotal &&
                    _.uniqBy(this.props.competeData.find( r => r.groupId === tabItem.groupId && r.segmentId === tabItem.segmentId).competitorTotal, "competitorId").map((item, index) => {
                      return (
                        <div className="define-select-box">
                          <div className="form-group">
                            <select
                              className="form-control competiorsOptions"
                              style={{ height: "34px" }}
                              value={item.competitorId}
                              disabled
                              onChange={e => this.props.onChangeCompetitors(e)}
                            >
                              {this.props.competitorsGroupsData.map(
                                (name, key) => {
                                  return (
                                    <option value={name.competitorId}>
                                      {name.competitorName}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                          </div>
                        </div>
                      );
                    })}
                  <table className="compete-capability-table margin-top">
                    <thead>
                      <tr>
                        {this.props.competitorsGroupsData.map((name, key) => {
                          if (name.important) {
                            return (
                              <th className="parent-th">
                                <th className="child-th">
                                  Rating <br /> (1-10)
                                </th>
                                <th className="child-th">Score</th>
                              </th>
                            );
                          }
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.competeData &&
                        !_.isEmpty(this.props.benefitsData) &&
                        this.props.competeData.map((i, index) => {
                          if ( groupId === i.groupId && segmentId === i.segmentId ) {
                            let oldI = this.props.oldData.find( r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId );
                            if(!oldI){
                              oldI = this.props.competeData.find( r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId  && i.new)
                            }

                            return (
                              <tr>
                                {_.uniqBy( i.competitorTotal, "competitorId").map((competitorsData, key) => {
                                  return (
                                    <td className="parent-td">
                                      <td className="child-td">
                                        <div className="td-box">
                                          {i.criticalCapacity.map(
                                            (critItem, index) => {
                                              let defData = critItem.competitors ? critItem.competitors.find( r => r.competitorId === competitorsData.competitorId ) : false;

                                              let oldDefData = oldI.criticalCapacity.find( r => r.id === critItem.id );

                                              let val = oldDefData.competitors ? oldDefData.competitors.find( r => r.competitorId === competitorsData.competitorId ) : false;

                                              let newVal = defData ? defData.rating : 1;

                                              let oldVal = val ? val.rating : 1;
                                              return (
                                                <div className="td-box-small">
                                                  <select
                                                    disabled={this.props.result ? true : false }
                                                    className="form-control"
                                                    value={ defData ? defData.rating : 1}
                                                    onChange={e => this.props.onChangeCompetitorsRatingValue(e,i,competitorsData,index)}
                                                    style={{ outline: "none" }}
                                                  >
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                  </select>
                                                  {+newVal - +oldVal !== 0 && (
                                                    <div className="position-number">
                                                      {+newVal - +oldVal}
                                                    </div>
                                                  )}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </td>
                                      <td className="child-td">
                                        <div className="td-box">
                                          {i.criticalCapacity.map( (critItem, index) => {
                                              let oldItem = oldI.criticalCapacity.find(r => r.id === critItem.id);

                                              let rateVal = critItem.competitors ? critItem.competitors.find(r =>r.competitorId === competitorsData.competitorId) : { rating: "1" };

                                              let rateOldVal = oldItem.competitors ? oldItem.competitors.find(r =>r.competitorId ===competitorsData.competitorId): { rating: "1" };

                                              let valScore = rateVal? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;

                                              let valOldScore = rateOldVal ? +oldItem.ccWt * +rateOldVal.rating : +oldItem.ccWt;

                                              let newVal = valScore ? valScore : critItem.ccWt;

                                              let oldVal = valOldScore ;

                                              countConpenScore.push({
                                                score:  valScore,
                                                competitorId: competitorsData.competitorId,
                                                difference:  +newVal - +oldVal
                                              });

                                              return (
                                                <div className="score-box">
                                                  {valScore ? valScore : critItem.ccWt}
                                                  { +newVal - +oldVal !== 0 && (
                                                    <div className="position-number">
                                                      {+newVal - +oldVal}
                                                    </div>
                                                  )}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </td>
                                    </td>
                                  );
                                })}

                                {((this.props.groupStepState && this.state.DataforAddDeleteOld && this.state.DataforAddDeleteNew && this.state.DataforAddDeleteNew[groupId + segmentId].length === this.state.DataforAddDeleteOld[ groupId + segmentId].length && !this.props.result) || (i.new && !this.props.result )) && (
                                    <td
                                      style={{
                                        width: "40px",
                                        display: "inline-block"
                                      }}
                                    >
                                      <i
                                        className="fa fa-minus minus-icon"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => this.props.onDelete(i)}
                                      />
                                    </td>
                                  )}
                              </tr>
                            );
                          }
                        })}
                      <tr className="last-row">
                      {
                            _.uniqBy(this.props.competeData.find(i => groupId === i.groupId && segmentId === i.segmentId).competitorTotal, "competitorId" ).map((competitorsData, key) => {
                              let val = 0;
                              let diff = 0;
                              if (uniq) {
                                const competitorData = uniq.competitorTotal.find(i => i.competitorId === competitorsData.competitorId);
                                competitorData ? diff -= competitorData.value : '';
                              }

                              countConpenScore.map((item, key) => {
                                if (
                                  item.competitorId ===
                                  competitorsData.competitorId
                                ) {
                                  val = val + +item.score;
                                  diff = diff + +item.difference;
                                }
                              });

                              return (
                                <td className="parent-td">
                                  <td className="child-td" />
                                  <td className=" child-td first-value">
                                    {diff !== 0 && (
                                      <div className="position-number">
                                        {diff}
                                      </div>
                                    )}
                                    <strong>{val}</strong>
                                  </td>
                                </td>
                              );
                            })

                        }
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {this.props.result === "true" &&
              this.props.differentialAdvantageData.getDifferentialAdvantageData
                .Items &&
              this.props.differentialAdvantageData.getDifferentialAdvantageData.Items[0].advantage.map(
                adv => {
                  if (
                    adv.groupId === tabItem.groupId &&
                    adv.segmentId === tabItem.segmentId
                  ) {
                    return (
                      <div className="col-md-6">
                        {adv.tactics.length !== 0 && (
                          <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-2">Tactics:</div>
                            <div className="col-md-10">
                              <div className="resultsDiv">
                                <ul
                                  style={{
                                    listStyle: "none",
                                    paddingLeft: "0"
                                  }}
                                >
                                  {adv.tactics.map(tactics => {
                                    return <li>{tactics.name} </li>;
                                  })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                        {adv.focus.length !== 0 && (
                          <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-2">Focus:</div>
                            <div className="col-md-10">
                              <div className="resultsDiv">
                                <ul
                                  style={{
                                    listStyle: "none",
                                    paddingLeft: "0"
                                  }}
                                >
                                  {adv.focus.map(focus => {
                                    return <li>{focus.name} </li>;
                                  })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                        {adv.rules.length !== 0 && (
                          <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-2">Rules:</div>
                            <div className="col-md-10">
                              <div className="resultsDiv">
                                <ul
                                  style={{
                                    listStyle: "none",
                                    paddingLeft: "0"
                                  }}
                                >
                                  {adv.rules.map(rules => {
                                    return <li>{rules.name} </li>;
                                  })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  }
                }
              )}
            {this.props.groupStepState &&
              this.state.DataforAddDeleteOld &&
              this.state.DataforAddDeleteNew &&
              this.state.DataforAddDeleteNew[groupId + segmentId].length !==
                this.state.DataforAddDeleteOld[groupId + segmentId].length && (
                <div className="col-md-3" style={{ margin: "20px" }}>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={e =>
                        this.props.onAdd(groupId, segmentId, e.target.value)
                      }
                    >
                      <option value="">---add---</option>
                      {this.renderOptions(
                        this.state.DataforAddDeleteNew[groupId + segmentId],
                        this.state.DataforAddDeleteOld[groupId + segmentId]
                      )}
                    </select>
                  </div>
                </div>
              )}
            { !this.props.result && !this.props.competeData.find(i=> i.groupId === groupId && i.segmentId===segmentId && i.new) &&
              <button
                style={{ margin: "20px", marginLeft: '27px', float: 'left' }}
                className="btn btn-success"
                onClick={()=>this.props.onAddNewBenefit(groupId,segmentId)}
              >Add new benefit</button>
            }
          </div>
        </div>
      );
    });
    return (
      <div className="criteria-tabs-content attractiveness-tab-content">
        <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
          {tabs}
        </ul>
        <div className="tab-content benefitsTabcontent" id="myTabContent">
          {tabsContent}
        </div>
      </div>
    );
  }
}
export default WeighBenefitsTabs;



// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/RateBenefits/WeightBenefitsTabs/WeightBenefitsTabs.jsx